import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classNames from 'classnames';
var css = {
  "iconButton": "rui-vMXNe",
  "disable": "rui-afvlQ"
};
import Icon from '../Icon/Icon';
export var PageArrow = function PageArrow(_ref) {
  var icon = _ref.icon,
    _ref$dataAutId = _ref['data-aut-id'],
    dataAutId = _ref$dataAutId === void 0 ? 'pageArrow' : _ref$dataAutId,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$disable = _ref.disable,
    disable = _ref$disable === void 0 ? false : _ref$disable;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: classNames(css.iconButton, _defineProperty({}, css.disable, disable)),
    onClick: onClick,
    "data-aut-id": dataAutId
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    color: disable ? 'blackDisabled' : 'blackIcons',
    size: 24
  }));
};
export default PageArrow;